import { get } from 'lodash'

export const getIndustriesMap = state => get(state, 'industries.entityMap', {})
